import Header from './components/Header.jsx'
import Hero from './components/Hero.jsx'
import About from './components/About.jsx'
import Markets from './components/Markets.jsx'
import Capabilities from './components/Capabilities.jsx'
import StoryMotion from './components/StoryMotion.jsx'
import Expertise from './components/Expertise.jsx'
import Reach from './components/Reach.jsx'
import StrategicValue from './components/StrategicValue.jsx'
import Proof from './components/Proof.jsx'
import Leadership from './components/Leadership.jsx'
import BrokingValue from './components/BrokingValue.jsx'
import PlacementIntelligence from './components/PlacementIntelligence.jsx'
import Insights from './components/Insights.jsx'
import Approach from './components/Approach.jsx'
import FAQ from './components/FAQ.jsx'
import Contact from './components/Contact.jsx'
import Footer from './components/Footer.jsx'
import ScrollProgress from './components/ScrollProgress.jsx'
import { usePageEffects } from './usePageEffects.js'

function App() {
  usePageEffects()

  return (
    <>
      <ScrollProgress />
      <Header />
      <main id="top">
        <Hero />
        <About />
        <Markets />
        <Capabilities />
        <StoryMotion />
        <Expertise />
        <Reach />
        <StrategicValue />
        <Proof />
        <Leadership />
        <BrokingValue />
        <PlacementIntelligence />
        <Insights />
        <Approach />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  )
}

export default App
